import {scrollItemId} from "./ListItemGroup";
import {
    IReactiveCourseWorkContentItem,
    IReactiveEventContentItem,
    IReactiveNewsContentItem
} from "../SchoolFeedContentItem";
import WatsonApi from "../../../backends/WatsonApi";

export function isEvent(item: EventContentItem | ContentItem): item is EventContentItem {
    return (item as EventContentItem).is_event === true;
}

export function isMedia(item: MediaContentItem | ContentItem): item is MediaContentItem {
    return (item as MediaContentItem).is_media === true;
}

export function isFile(item: FileContentItem | ContentItem): item is FileContentItem {
    return (item as FileContentItem).is_file === true;
}

export function isFolder(item: FileContentItem | ContentItem): item is FileContentItem {
    return (item as FolderContentItem).is_folder === true;
}

export function isNews(item: NewsContentItem | ContentItem): item is NewsContentItem {
    return (item as NewsContentItem).is_news === true;
}

export function getListItemIndex(id: string) {
    const items = Array.from(document.getElementsByClassName(scrollItemId) as HTMLCollectionOf<HTMLDivElement>);

    return items.findIndex(el => el.id === id);
}

export async function unpublishItem(item: IReactiveNewsContentItem | IReactiveEventContentItem | IReactiveCourseWorkContentItem) {
    const client = await WatsonApi();
    const result = await client.apis.organizations.organizations_content_items_partial_update({
        id: item.id,
        organization_pk: item.organization_id,
        data: {"user_published": !item.published},
    });
    item.update(result.obj);
}
